'use strict';
const React = require('react');
const BaseComponent = require('../../../../shared/base');

class SortViewOptionsComponent extends BaseComponent {
    render() {
        return (
            <React.Fragment>
                <option value="-created">Items-Más nuevos</option>
                <option value="created">Items-Más antiguos</option>
                <option value="price">Precio-Más bajo</option>
                <option value="-price">Precio-Más alto</option>
                <option value="name">Nombre-Ascendente</option>
                <option value="-name">Nombre-Descendente</option>
            </React.Fragment>
        );
    }
}

module.exports = SortViewOptionsComponent;